import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useApp } from '../data/ColisContext';

export default function RequireAgent({ children }) {
  const { user, authBooting } = useApp();
  const location = useLocation();

  const isAgent = user?.agent === true || user?.agent === 1 || user?.agent === '1';

  if (authBooting) return null;

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (!(isAgent || user?.is_admin)) {
    return <Navigate to="/" replace />;
  }

  return children;
}
